import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var AverageIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3.05 1c.541 0 .987.42 1.044.96l.006.117v17.77h17.85c.58 0 1.05.481 1.05 1.076 0 .555-.41 1.012-.936 1.07L21.95 22H3.05a1.06 1.06 0 01-1.044-.96L2 20.923V2.077C2 1.482 2.47 1 3.05 1zm6.936 10.164C9.453 14.367 7.76 17 6 17a1 1 0 010-2c.454 0 1.622-1.817 2.014-4.164C8.672 6.886 10.2 4 13 4s4.328 2.885 4.986 6.836C18.378 13.183 19.546 15 20 15a1 1 0 010 2c-1.76 0-3.453-2.633-3.986-5.836C15.51 8.141 14.376 6 13 6s-2.51 2.14-3.014 5.164z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
AverageIcon.isCarinaIcon = true;
export default AverageIcon;
